// extracted by mini-css-extract-plugin
export default {"emptyList":"EmptyListMessage_emptyList__0SlpV"};